<template>
  <div class="raffle">
    <section class="bh-section">
      <div class="bh-container">
        <p class="raffle__year">2027</p>
        <h1 class="bh-section__title">Banquet and raffle</h1>
        <p class="bh-section__lead">
          February 27, 2027. The venue will be announced here.
        </p>
        <p class="raffle__soon">Coming Soon</p>
      </div>
    </section>

    <section class="bh-section raffle__past">
      <div class="bh-container">
        <h2 class="bh-section__title">Past</h2>
        <div class="raffle__flyers">
          <figure>
            <img
              :src="banquetFlyer"
              alt="2026 Lion Hunters Banquet flyer"
            />
          </figure>
          <figure>
            <img :src="raffleFlyer" alt="2026 raffle flyer" />
          </figure>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "RafflePage",
  data() {
    return {
      banquetFlyer: require("@/assets/banquetFlyer.png"),
      raffleFlyer: require("@/assets/raffleFlyer.png"),
    };
  },
};
</script>

<style scoped>
.raffle {
  text-align: left;
}

.raffle__year {
  margin: 0 0 0.5rem;
  color: var(--bh-amber);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.raffle__soon {
  display: inline-block;
  margin: 1.25rem 0 0;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(193, 122, 47, 0.12);
  color: var(--bh-amber-hover);
  font-size: 0.9rem;
  font-weight: 600;
}

.raffle__past {
  padding-top: 0;
}

.raffle__flyers {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  margin-top: 1.5rem;
}

.raffle__flyers figure {
  margin: 0;
  background: var(--bh-surface);
  border: 1px solid var(--bh-border);
  border-radius: var(--bh-radius);
  overflow: hidden;
}

.raffle__flyers img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 960px) {
  .raffle__flyers {
    grid-template-columns: 1fr;
  }
}
</style>
